import { cva, type VariantProps } from "class-variance-authority";
import { type ComponentProps, forwardRef } from "react";

import { CAMPAIGN_TYPES } from "common/constants";
import { cn } from "common/helpers/utils";
import type { CampaignType } from "common/types";

const campaignTypeIconVariants = cva(
  "inline-flex shrink-0 items-center justify-center",
  {
    variants: {
      size: {
        xs: "size-6 rounded-lg [&_svg]:size-3",
        sm: "size-8 rounded-xl [&_svg]:size-4",
        md: "size-10 rounded-2xl [&_svg]:size-5",
        lg: "size-12 rounded-3xl [&_svg]:size-6",
      },
      variant: {
        default: "bg-black-100",
        drip: "bg-blue-100 [&_svg]:fill-blue-700",
      },
    },
    defaultVariants: {
      size: "md",
      variant: "default",
    },
  },
);

type CampaignTypeIconProps = Omit<ComponentProps<"span">, "children"> &
  Omit<VariantProps<typeof campaignTypeIconVariants>, "variant"> & {
    type: CampaignType;
    isDrip: boolean;
  };

const CampaignTypeIcon = forwardRef<HTMLSpanElement, CampaignTypeIconProps>(
  ({ className, size, type, isDrip, ...props }, ref) => {
    const { icon: Icon } = CAMPAIGN_TYPES[type];

    return (
      <span
        ref={ref}
        className={cn(
          campaignTypeIconVariants({
            size,
            className,
            variant: isDrip ? "drip" : "default",
          }),
        )}
        {...props}
      >
        <Icon weight="duotone" />
      </span>
    );
  },
);
CampaignTypeIcon.displayName = "CampaignTypeIcon";

export default CampaignTypeIcon;
